import { createAction } from '@ngrx/store';

export const sessionExpired = createAction('[Core] Session Expired');
export const loadChunksError = createAction('[Core] Load Chunks Error');
export const logoClicked = createAction('[Core] Logo Clicked');
